import { createAction, props } from '@ngrx/store';

export const markDirty = createAction('[Navigation] Mark State Dirty', props<{ key: string }>());

export const markClean = createAction('[Navigation] Mark State Clean', props<{ key: string }>());
